// extracted by mini-css-extract-plugin
export default {"reviewPrecaution":"ReviewPrecaution_reviewPrecaution__nsDnm"};